import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { BinaryDependencyConfidence } from '../../../../shared/binaryDependencyConfidence';
import { IssueFilterKeys } from '../../../../shared/issuesV2';
import * as IssuesV2Store from '../../../redux/issuesV2';
import { useSetFilterHasChanged } from '../../../redux/savedFilters/hooks';
import { FilterPanel } from '../../generic/Filter';
import FilterCardCheckboxes from '../../generic/Filter/FilterCardCheckboxes';
import useFetchIssuesAction from '../IssuesInbox/hooks/useFetchIssuesAction';
import type { SelectOption } from '../../../types';
import type { SelectedOptionsProps } from '../../generic/Filter';

const FILTER_OPTIONS: SelectOption[] = [
  { value: BinaryDependencyConfidence.High, label: 'High' },
  { value: BinaryDependencyConfidence.Medium, label: 'Medium' },
  { value: BinaryDependencyConfidence.Low, label: 'Low' },
  { value: BinaryDependencyConfidence.Unknown, label: 'Unknown' },
];

const ConfidenceIssueFilter: VoidFunctionComponent<Omit<SelectedOptionsProps, 'onSelect'>> = ({ selectedOptions }) => {
  const setFilters = useFetchIssuesAction(IssuesV2Store.actions.setFilter);
  const stateFilters = useSelector(IssuesV2Store.selectors.getFilter);
  const setFilterHasChanged = useSetFilterHasChanged();

  const selectedCheckboxes = (selectedOptions ?? []).map((option: string) => ({
    label: FILTER_OPTIONS.find(filterOption => filterOption.value === option)?.label || option,
    value: option,
  }));

  const onCheckboxChange = (newSelected: SelectOption[]) => {
    setFilters({
      ...stateFilters,
      [IssueFilterKeys.Confidence]: newSelected.map(({ value }) => value),
    });
    setFilterHasChanged(true);
  };

  return (
    <FilterPanel>
      <FilterCardCheckboxes
        label="Dependency Confidence"
        options={FILTER_OPTIONS}
        values={selectedCheckboxes}
        onChange={onCheckboxChange}
        testId="issues-confidence-filters"
      />
    </FilterPanel>
  );
};

export default ConfidenceIssueFilter;
